// extracted by mini-css-extract-plugin
export default {"wrapper":"SettingsPage_wrapper__av1cZ"};